<template>
  <div class="bootcamp-content">
    <div v-if="!hasAccess" class="bootcamp-content__access-mask">
      <div class="bootcamp-content__access-action">
        <p class="bootcamp-content__premium-cta">
          <Passes
            passName="Premium"
            :size="50"
            class="bootcamp-content__premium-cta--icon"
          />
          Premium Plan Required
        </p>
        <button
          v-if="canUpgradePlan"
          class="bootcamp-content__access-btn btn__large"
          @click="$emit('requestPlanUpgrade')"
        >
          UPGRADE
          <LockIcon
            class="btn__large-icon bootcamp-content__access-btn--icon"
          />
        </button>
        <a
          v-else
          class="btn__large bootcamp-content__access-btn"
          :href="`//${plansLink}`"
          id="ine-link"
        >
          GET ACCESS
          <LockIcon
            class="btn__large-icon bootcamp-content__access-btn--icon"
          />
        </a>
      </div>
    </div>
    <div
      v-for="group in content"
      :key="`group-${group.name}`"
      :class="[
        'bootcamp-content__group',
        !hasAccess && 'bootcamp-content__group--no-access',
      ]"
    >
      <p class="bootcamp-content__group-title">{{ group.name }}</p>
      <div
        v-for="topic in group.content"
        :key="`topic-${topic.name}`"
        class="bootcamp-content__topic"
      >
        <p class="bootcamp-content__topic-title">{{ topic.name }}</p>
        <Level
          v-for="level in filterContent(topic.content)"
          :key="level.id"
          class="bootcamp-content__level"
          :media="level"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Passes from '@/components/properties/Passes.vue'
import LockIcon from '@/assets/icons/course/lock_icon.svg'
import Level from './content/Level.vue'

export default {
  name: 'Content',
  components: { Passes, Level, LockIcon: { ...LockIcon, name: 'LockIcon' } },
  props: {
    content: {
      type: Array,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    canUpgradePlan: {
      type: Boolean,
      require: false,
    },
  },
  computed: {
    ...mapState({
      videos: state => state.content.currentVideos,
      quizzes: state => state.content.currentQuizzes,
      plansLink: state => state.app.plansLink,
    }),
  },
  methods: {
    filterContent(content) {
      return content.reduce((acc, c) => {
        const { uuid, content_type } = c
        const found = this.getContent({ uuid, content_type })
        if (found) acc.push(found)
        return acc
      }, [])
    },
    findVideo(uuid) {
      return {
        ...this.videos.find(vid => vid.id === uuid),
        content_type: 'video',
      }
    },
    findQuiz(uuid) {
      return {
        ...this.quizzes.find(quiz => quiz.id === uuid),
        name: 'Quiz',
        content_type: 'quiz',
      }
    },
    getContent({ uuid, content_type }) {
      const included = ['video', 'quiz']
      if (included.includes(content_type)) {
        if (content_type === 'video') {
          return this.findVideo(uuid)
        }
        return this.findQuiz(uuid)
      }
    },
  },
}
</script>

<style lang="scss">
.bootcamp-content {
  width: 100%;
  margin-bottom: 30px;
  position: relative;
  &__access-mask {
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }
  &__access-action {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__premium-cta {
    max-width: 180px;
    display: flex;
    align-items: center;
    font-family: var(--font-bold);
    font-size: rem(16px);
    color: white;
    &--icon {
      margin: 0 5px 0 0;
    }
  }
  &__access-btn {
    text-align: left;
    display: flex;
    align-items: center;
    &--icon {
      position: relative;
      margin: -8px -15px 0 25px;
      @include desktop {
        margin: -8px -20px 0 25px;
      }
    }
  }
  &__group {
    margin-bottom: 10px;
    &--no-access {
      padding: 15px;
    }
  }
  &__group-title {
    font-size: rem(18px);
    font-family: var(--font-bold);
    color: var(--white);
    padding: 0;
    margin: 0 auto 15px auto;
    text-align: center;
  }
  &__topic {
    margin-bottom: 20px;
  }
  &__topic-title {
    font-size: rem(16px);
    font-family: var(--font-bold);
    color: var(--orange);
    padding: 5px 0 5px 10px;
    margin: 0;
  }
}
</style>
